import Link from "next/link";
import { useTranslation } from "next-i18next";

import { LogoAnimated } from "@/components/LogoAnimated";
import { LINKS } from "@/constants/links";

type LogoProps = {
  className?: string;
  leftAlign?: boolean;
};

/**
 * @todo (gvonkoss) this should move into the root src/components folder
 * as it is a shared component between the Header and Footer
 */
export const Logo = ({ className }: LogoProps) => {
  const { t } = useTranslation("header");

  return (
    <Link
      href={LINKS.HOME}
      aria-label={t("navigation.home")}
      className={className}
    >
      <LogoAnimated />
    </Link>
  );
};
